import { useContext } from 'react';
import SpeciesContext from '@/context/SpeciesContext';

const useSpecies = () => useContext(SpeciesContext);

export default useSpecies;
